import { Component, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-dialog',
    template: `
    <h2 mat-dialog-title>Confirm Action</h2>
    <mat-dialog-content>
      {{ dialogText }}
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-button color="primary" (click)="confirm()">Confirm</button>
    </mat-dialog-actions>
  `,
    standalone: false
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { dialogText: string }
  ) {}


  get dialogText(): string {
    return this.data.dialogText;
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}

// Are you sure you want to perform this action?